import { FleetActionTypes as types } from './actions';

const initialState = {
  vehicles: { data: [], loading: true },
  selection: null,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_VEHICLES_SUCCESS:
      return { ...state, vehicles: { data: action.payload, loading: false } };
    case types.FETCH_VEHICLES_FAILURE:
      return { ...state, vehicles: { ...state.vehicles, loading: false } };
    case types.SET_SELECTED_VEHICLE:
      return { ...state, selection: action.payload };
    case types.VEHICLE_UPDATE_SUCCESS:
      return {
        ...state,
        vehicles: {
          ...state.vehicles,
          data: state.vehicles.data.map((v) => (v.id === action.payload.id ? action.payload : v)),
        },
        selection: action.payload,
      };
    case types.VEHICLE_DELETED:
      return {
        ...state,
        vehicles: {
          ...state.vehicles,
          data: state.vehicles.data.filter((v) => v.id !== action.payload),
        },
        selection: null,
      };
    default:
      return state;
  }
}

export default reducer;
